
import { defineComponent } from 'vue';
import AdForm from './AdForm.vue';
import { mapGetters } from 'vuex';

export default defineComponent({
  components: {
    AdForm,
  },
  computed: {
    ...mapGetters(['isLoggedIn']),
  },
  created() {
    if (this.isLoggedIn) {
      this.$router.push({ name: 'AdFormCreate' });
    }
  },
});
